// A API (corp-backend/corp-api) às vezes manda, para registros específicos já calculados no
// passado, o índice/causa/grupo no formato de CHAVE DE TRADUÇÃO LEGADA COMPLETA
// (`<producao>.agriness.<namespace>.<codigo>`, ex: `swines.agriness.performances.mortality_rate`)
// em vez do código curto esperado (`mortality_rate`). Reproduz também no Angular legado, então é
// dado do backend, não bug de lógica de tradução — consertar a origem está fora de escopo.
// Esta função extrai só o último segmento pra manter o front funcionando com o código curto.
export function normalizeIndexCode(value: string): string {
  return value.includes('.') ? (value.split('.').pop() ?? value) : value;
}
